<template>
	<div>
	<div class="cWrap" v-for="(item,index) in datas" :key="index">
	<div :class="{cWraps:true,cWraps1:true}" >
					
		<!-- <div :class="{cRectyh:true,c2Rectyh:true}" @touchstart.prevent="touch1(item)"
@click="mm"  @touchend="getTouchEnd" v-if="(item.recordId!=currentb)">

		    <div class="ltop" v-if="item.supportStatus=='4'" @click.stop="stopDefault">已完成</div>
			<div class="ltop" v-else-if="item.supportStatus=='0'" style="background:#ffb617" @click.stop="stopDefault">待响应</div>
		    <div class="ltop" v-else-if="item.supportStatus=='1'||item.supportStatus=='3'" style="background:#0BBCB2" @click.stop="stopDefault">响应中</div>
			<div class="ltop" v-else-if="item.supportStatus=='2'"  @click.stop="stopDefault">已响应</div>
			<div class="tserve">
				工单编号：{{item.recordCode}}
			</div>
			<div class="tserve1" @touchstart.prevent="touchs(item)">
				<div class="tserve11"></div>
				<div class="tserve11"></div>
				<div class="tserve11"></div>
			</div>
			
			<div v-if="(item.responseType=='3')">
				<div v-if="(item.maintenanceType=='0')">
					<div class="txt">{{item.supportType}}</div>
					<div class="subtxt">{{item.maintenanceName}} {{item.maintenanceTel}} {{item.maintenanceCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
				<div v-if="(item.maintenanceType=='1')">
					<div class="txt">{{item.supportType}}</div>
					<div class="subtxt">{{item.assetsUserName}} {{item.assetsUserTel}} {{item.assetsUserCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
			</div>
			<div v-if="(item.responseType=='1'||item.responseType=='2')">
				<div v-if="(item.maintenanceType=='0')">
					<div class="txt">{{item.assetsName}}</div>
					<div class="subtxt">{{item.maintenanceName}} {{item.maintenanceTel}} {{item.maintenanceCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
				<div v-if="(item.maintenanceType=='1')">
					<div class="txt">{{item.assetsName}}</div>
					<div class="subtxt">{{item.assetsUserName}} {{item.assetsUserTel}} {{item.assetsUserCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
			</div>
		    <div v-if="(currentb==item.recordId)&&item.show&&(item.responseType=='3')">
				<div class="evaluate" style="display:flex;z-index:3000" v-if="item.supportStatus=='4'&&item.assessStatus==1" >
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
				<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='4'&&item.assessStatus==0" >
					<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="estimate(item)">立即评价</van-button>
				</div>
				
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='1'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='0'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='3'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
				<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='2'">
					<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;"  @click="confirm(item)">确认完成</van-button>
				</div>
		    </div>
			<div  v-if="(item.recordId==currentb)&&!item.show&&(item.responseType=='3')">
				<div class="evaluate" style="display:flex;z-index:1000">
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
			</div>
			<div v-if="(item.recordId==currentb)&&item.show&&(item.responseType=='1'||item.responseType=='2')">
					<div class="evaluate" style="z-index:3000" v-if="item.supportStatus=='4'&&item.assessStatus==1">
						<van-button class="btnuSty" @click.stop="toDetail(item)">详情</van-button>
					</div>
					<div class="evaluate" style="z-index:1000" v-else-if="item.supportStatus=='4'&&item.assessStatus==0" >
						<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="estimate(item)">立即评价</van-button>
					</div>
					<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='1'">
						<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
						<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
					</div>
					<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='0'">
						<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
						<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
					</div>
					<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='3'">
						<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
						<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
					</div>
					<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='2'">
						<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="confirm(item)">确认完成</van-button>
					</div>
			</div>
			<div  v-if="(item.recordId==currentb)&&!item.show&&(item.responseType=='1'||item.responseType=='2')">
				<div class="evaluate" style="display:flex;z-index:1000">
					<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
				</div>
			</div>
			<div>
				<div class="response" v-if="item.responseType=='3'">快速响应</div>
				<div class="response" v-if="item.responseType=='2'">软件响应</div>
				<div class="response" v-else-if="item.responseType=='1'">硬件响应</div>
			</div>
		    <div>
				<div class="response1" v-if="item.maintenanceType=='0'">用户提交</div>
				<div class="response1" v-else-if="item.maintenanceType=='1'">工程师提交</div>
			</div>
		</div> -->
		
		
		<div :class="{cRectyh:true,c2Rectyh:true}">
			<div class="ltop" v-if="item.supportStatus=='4'" @click.stop="stopDefault">已完成</div>
			<div class="ltop" v-else-if="item.supportStatus=='0'" style="background:#ffb617" @click.stop="stopDefault">待响应</div>
			<div class="ltop" v-else-if="item.supportStatus=='1'||item.supportStatus=='3'" style="background:#0BBCB2" @click.stop="stopDefault">响应中</div>
			<div class="ltop" v-else-if="item.supportStatus=='2'"  @click.stop="stopDefault">已响应</div>
			<!-- <div class="finish" v-if="item.supportStatus=='2'">--工程师处理完成</div>
			<div class="finish" v-if="item.supportStatus=='3'">--工程师已流转</div> -->
			<div class="tserve">
				工单编号：{{item.recordCode}}
			</div>
			<div class="tserve1" @click.stop="touchs(item)">
				<div class="tserve11"></div>
				<div class="tserve11"></div>
				<div class="tserve11"></div>
			</div>
			<!-- <div class="tserve" style="text-align:right">
				<div v-if="(item.responseType=='3')">
					<div v-if="(item.maintenanceType=='0')">
						<div class="subtxt" style="text-align:right">{{item.maintenanceName}} {{item.maintenanceTel}}</div>
					</div>
					<div v-if="(item.maintenanceType=='1')">
						<div class="subtxt" style="text-align:right">{{item.assetsUserName}} {{item.assetsUserTel}}</div>
					</div>
				</div>
				<div v-if="(item.responseType=='1'||item.responseType=='2')">
					<div v-if="(item.maintenanceType=='0')"> 
						<div class="subtxt" style="text-align:right">{{item.maintenanceName}} {{item.maintenanceTel}}</div>
					</div>
					<div v-if="(item.maintenanceType=='1')">
						<div class="subtxt" style="text-align:right">{{item.assetsUserName}} {{item.assetsUserTel}}</div>
					</div>
				</div>
			</div> -->
			<div v-if="(item.responseType=='3')">
				<div v-if="(item.maintenanceType=='0')">
					<div class="txt">{{item.supportType}}</div>
					<div class="subtxt">{{item.maintenanceName}} {{item.maintenanceTel}} {{item.maintenanceCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
				<div v-if="(item.maintenanceType=='1')">
					<div class="txt">{{item.supportType}}</div>
					<div class="subtxt">{{item.assetsUserName}} {{item.assetsUserTel}} {{item.assetsUserCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
			</div>
			<div v-if="(item.responseType=='1'||item.responseType=='2')">
				<div v-if="(item.maintenanceType=='0')">
					<div class="txt">{{item.assetsName}}</div>
					<div class="subtxt">{{item.maintenanceName}} {{item.maintenanceTel}} {{item.maintenanceCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
				<div v-if="(item.maintenanceType=='1')">
					<div class="txt">{{item.assetsName}}</div>
					<div class="subtxt">{{item.assetsUserName}} {{item.assetsUserTel}} {{item.assetsUserCompanyName}}</div>
					<div class='flexRight'>
						<div class="subtxtn">最迟解决时间：{{item.lastFinishTime}}</div>
						<div class="subtxtn">实际完成时间：{{item.engineerFinishTime}}</div>
					</div>
				</div>
			</div>
			 <div v-if="(currentb==item.recordId)&&item.show&&(item.responseType=='3')">
				<div class="evaluate" style="display:flex;z-index:3000" v-if="item.supportStatus=='4'&&item.assessStatus==1" >
					<van-button class="btnuSty" style="margin-right:0;" @click="toDetails(item)">详情</van-button>
				</div>
				<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='4'&&item.assessStatus==0" >
					<!-- <van-button class="btnuSty" @click="toDetails(item)">详情</van-button> -->
					<van-button class="btnuSty" style="margin-right:0;border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="estimate(item)">立即评价</van-button>
				</div>
				<!-- <div class="evaluate" v-if="item.supportStatus==1" @click="toDetail(item)">详情</div>
				<div class="evaluate" v-else-if="item.supportStatus==3" @click="toDetail(item)">详情</div> -->
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='1'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
				</div>
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='0'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
				</div>
				<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='3'">
					<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
					<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
				</div>
				<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='2'">
					<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
					<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;"  @click="confirm(item)">确认完成</van-button>
				</div>
			 </div>
				<div  v-if="(item.recordId==currentb)&&!item.show&&(item.responseType=='3')">
					<div class="evaluate" style="display:flex;z-index:1000">
						<van-button class="btnuSty" @click="toDetails(item)" style="margin-right:0;">详情</van-button>
					</div>
				</div>
				<div v-if="(item.recordId==currentb)&&item.show&&(item.responseType=='1'||item.responseType=='2')">
						<div class="evaluate" style="z-index:3000" v-if="item.supportStatus=='4'&&item.assessStatus==1">
							<van-button class="btnuSty" style="margin-right:0;" @click.stop="toDetails(item)">详情</van-button>
						</div>
						<div class="evaluate" style="z-index:1000" v-else-if="item.supportStatus=='4'&&item.assessStatus==0" >
							<!-- <van-button class="btnuSty" @click="toDetails(item)">详情</van-button> -->
							<van-button class="btnuSty" style="margin-right:0;border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="estimate(item)">立即评价</van-button>
						</div>
						<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='1'">
							<!-- <div style="width:100%;height:100%;opacity:0.6;position:absolute;top:0;left:0;"></div> -->
							<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
							<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
						</div>
						<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='0'">
							<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
							<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
						</div>
						<div class="evaluate1" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='3'">
							<van-button class="btnuSty" @click.stop="close(item)">关闭</van-button>
							<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
						</div>
						<div class="evaluate" style="display:flex;z-index:1000" v-else-if="item.supportStatus=='2'">
							<van-button class="btnuSty" @click="toDetails(item)">详情</van-button>
							<van-button class="btnuSty" style="border:none;background: linear-gradient(180deg,#36b3fe, #0080ff);color:#fff;" @click="confirm(item)">确认完成</van-button>
						</div>
				</div>
				<div  v-if="(item.recordId==currentb)&&!item.show&&(item.responseType=='1'||item.responseType=='2')">
					<div class="evaluate" style="display:flex;z-index:1000">
						<van-button class="btnuSty" @click="toDetails(item)" style="margin-right:0;">详情</van-button>
					</div>
					<!-- <div class="evaluate" style="display:flex;z-index:3000">
						<van-button class="btnuSty" @click="toDetail(item)">详情</van-button>
					</div> -->
				</div>
				<div>
					<div class="response" v-if="item.responseType=='3'">快速响应</div>
					<div class="response" v-if="item.responseType=='2'">软件响应</div>
					<div class="response" v-else-if="item.responseType=='1'">硬件响应</div>
				</div>
			 <div>
				<div class="response1" v-if="item.maintenanceType=='0'">用户提交</div>
				<div class="response1" v-else-if="item.maintenanceType=='1'">工程师提交</div>
			</div>
			 <div>
				<div class="response1" v-if="item.maintenanceType=='0'">用户提交</div>
				<div class="response1" v-else-if="item.maintenanceType=='1'">工程师提交</div>
			</div>
		</div>
		
		</div>
	</div>
	</div>
	</div>
</template>
<script>
    export default{
        props:['datas','currentb'],
        data(){
            return{
				fshow:false,
				tShow:false,
                show:false,
				show1:1,
				timer11:null
            }
        },
		
        methods:{
			getTouchMove(){
				this.fshow=true
				// alert('uu')
				// alert(this.fshow)
			},
			mm(){
				// alert('ttt')
			},
			touchs(item){
				this.currentb=item.recordId
				this.$emit('fatherMethod',this.currentb)
			},
			getTouchEnd(){
				clearTimeout(this.timer11)
			},
			touch1(item){
				clearTimeout(this.timer11)
				this.timer11=setTimeout(()=>{
					this.currentb=item.recordId
					this.$emit('fatherMethod',this.currentb)
					// alert('mmm')
				},500)
				return false
			},
			close(item){
				this.show1=1;
				this.$emit('close',this.show1,item.recordId);
			},
			toDetails(item){
				// alert('uuu')
				let bool=(this.$store.state.user.userInfo.role==1)
				
				if(bool){
					if(item.maintenanceType==0){
						if(item.maintenanceId==this.$store.state.user.userInfo.userId){
								if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='2')){
									this.$router.push({path:'/confirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='3')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='1')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='0')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/restimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='2')){
									this.$router.push({path:'/rconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='1')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='3')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='0')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								
								if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='2')){
									this.$router.push({path:'/qtconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId,froms:1}})
								}else if(item.responseType=='3'&&(item.supportStatus=='3')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='1')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='0')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
							// }
						}else{
							if(item.responseType=='1'){
								this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='2'){
								this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='3'){
								this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}
						}
					}else{
							if(item.assetsUserId==this.$store.state.user.userInfo.userId){
									if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==1){
										this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==0){
										this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='1'&&(item.supportStatus=='2')){
										this.$router.push({path:'/confirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
									}else if(item.responseType=='1'&&(item.supportStatus=='3')){
										this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='1'&&(item.supportStatus=='1')){
										this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='1'&&(item.supportStatus=='0')){
										this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}
									
									if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==1){
										this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==0){
										this.$router.push({path:'/restimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='2'&&(item.supportStatus=='2')){
										this.$router.push({path:'/rconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
									}else if(item.responseType=='2'&&(item.supportStatus=='1')){
										this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='2'&&(item.supportStatus=='3')){
										this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='2'&&(item.supportStatus=='0')){
										this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}
									
									
									if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==1){
										this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==0){
										this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='3'&&(item.supportStatus=='2')){
										this.$router.push({path:'/qtconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId,froms:1}})
									}else if(item.responseType=='3'&&(item.supportStatus=='3')){
										this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='3'&&(item.supportStatus=='1')){
										this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}else if(item.responseType=='3'&&(item.supportStatus=='0')){
										this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
									}
								// }
							}else{
								if(item.responseType=='1'){
									this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'){
									this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'){
									this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
							}
					}
				}else{
					if(item.maintenanceType==0){
						if(item.maintenanceId==this.$store.state.user.userInfo.userId){
								if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='2')){
									this.$router.push({path:'/confirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='1')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='3')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='0')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/restimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='2')){
									this.$router.push({path:'/rconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='1')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='3')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='0')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								
								if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='2')){
									this.$router.push({path:'/qtconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='3')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='1')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='0')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
							// }
						}else{
							if(item.responseType=='1'){
								this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='2'){
								this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='3'){
								this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}
						}
					}else{
						if(item.assetsUserId==this.$store.state.user.userInfo.userId){
								if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='2')){
									this.$router.push({path:'/confirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='1')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='3')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='1'&&(item.supportStatus=='0')){
									this.$router.push({path:'/gdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/restimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='2')){
									this.$router.push({path:'/rconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='1')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='3')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='2'&&(item.supportStatus=='0')){
									this.$router.push({path:'/rgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
								
								if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==1){
									this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&item.supportStatus=='4'&&item.assessStatus==0){
									this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='2')){
									this.$router.push({path:'/qtconfirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='3')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='1')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}else if(item.responseType=='3'&&(item.supportStatus=='0')){
									this.$router.push({path:'/qtgdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
								}
							// }
						}else{
							if(item.responseType=='1'){
								this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='2'){
								this.$router.push({path:'/rdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}else if(item.responseType=='3'){
								this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
							}
						}
					}
				}

			},
            stopDefault(){
            	
            },
            toDetail(item){
				this.$router.push({path:'/detailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
            },
            estimate(item){
				this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})  
            },
            confirm(item){
				let data={
				  "engineerId": item.engineerId,
				  "recordId":item.recordId,
				}
				this.$api.get('/app/support/supportFinish',{params:data}).then(res=>{
					if(res.data.code=="0000"&&res.data.message=="成功"){
						this.$router.push({path:'/estimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
						
					}
				})
			},
			toDetail3(item){
				this.$router.push({path:'/qtdetailInfo',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
			},
			estimate3(item){
				this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
				// if(this.$route.query.froms==1){
				// 	this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId,froms:1}})
				// }else{
				// 	this.$router.push({path:'/qtestimate',query:{recordId:item.recordId,recordItemId:item.recordItemId}})
				// }
			    
			},
			confirm3(item){
				let data={
				  "engineerId": item.engineerId,
				  "recordId":item.recordId,
				}
				this.$api.get('/app/support/supportFinish',{params:data}).then(res=>{
					if(res.data.code=="0000"&&res.data.message=="成功"){
						if(this.$route.query.froms==1){
							this.$router.push({path:'/qtestimate',query:{recordId:this.$route.query.recordId,recordItemId:item.recordItemId,froms:1}})
						}else{
							this.$router.push({path:'/qtestimate',query:{recordId:this.$route.query.recordId,recordItemId:item.recordItemId}})
						}
						
					}
				})
			}
        },
        mounted(){
				// document.getElementById('ele').addEventListener('contextmenu', function(e){
				//     e.preventDefault();
				// 	console.log(e)
				// 	return false
				// });
			
        },
		watch:{
			 currentb: {
				 handler(newValue, oldValue) {
					 this.currentb=newValue
				 },
				 immediate: true
			 }
		},
        created(){
			let bool=(this.$store.state.user.userInfo.role==1)
			this.datas.forEach(item=>{
				if(bool){
					if(item.maintenanceType==0){
						if(item.maintenanceId==this.$store.state.user.userInfo.userId){
							item.show=true
						}else{
							item.show=false
						}
					}else{
						if(item.assetsUserId==this.$store.state.user.userInfo.userId){
							item.show=true
						}else{
							item.show=false
						}
					}
					
					
				}else{
					if(item.maintenanceType==0){
						if(item.maintenanceId==this.$store.state.user.userInfo.userId){
							item.show=true
						}else{
							item.show=false
						}
					}else{
						if(item.assetsUserId==this.$store.state.user.userInfo.userId){
							item.show=true
						}else{
							item.show=false
						}
					}
				}
			})
        }
    }
</script>
<style scoped>
	*{
		-webkit-touch-callout:none;
		-webkit-user-select:none;
		-khtml-user-select:none;
		-moz-user-select:none;
		-ms-user-select:none;
		user-select:none;
	}
	.evaluate{
		display:flex;
		justify-content: center;
		align-items: center;
	    position:absolute;
		left:0;
		top:0;
	    bottom:0;
	    width: 100%;
	    background: linear-gradient(45deg,#36b3fe 3%, #0080ff 99%);
	    border-radius: 8px;
	    font-size:16px;
	    text-align:center;
	    line-height:37px;
	    font-weight:400;
		 background:rgba(0,0,0,.6);
	    color:#fff;
	}
	.evaluate1{
		display:flex;
		justify-content: center;
		align-items: center;
	    position:absolute;
	    left:0;
		top:0;
	    bottom:0;
	    width: 100%;
	    background:rgba(0,0,0,.6);
	    border-radius: 8px;
	    font-size:16px;
	    text-align:center;
	    line-height:37px;
	    font-weight:400;
	    color:#333;
		border-top:1px solid #999999;
	}
	.btnuStyn{
		width:154px;
		flex:0 0 154px;
	}
	.btnuSty{
		padding:0;
		width: 68px;
		height: 68px;
		line-height:68px;
		text-align: center;
		background: #ffffff;
		border-radius: 50%;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: center;
		color: #0080ff;
	}
	.btnuSty:nth-child(1){
		margin-right:18px;
	}
	.btnuSty:nth-child(2){
		background: linear-gradient(180deg,#36b3fe, #0080ff);
		color:#fff;
		border:none;
	}
	.cWraps{
		height:147px;
	}
	.cWraps1{
		height:120px;
	}
    .cRectyh{
        position:relative;
        width: 335px;
        height: 142px;
        margin:15px auto;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
    }
    .c2Rectyh{
        height: 124px;
    }
    .ltop{
        position:abosulte;
        top:0;
        left:0;
        width: 64px;
        height: 24px;
        background: #0080ff;
        border-radius: 8px 0px 8px 0px;
        font-size:12px;
        color:#fff;
        text-align:center;
        line-height:24px;
    }
	.tserve{
		display:flex;
		position:absolute;
		top:0px;
		left:71px;
		width:230px;
		height:24px;
		line-height:24px;
		font-size:12px;
		font-family: PingFang SC, PingFang SC-Regular;
		color: #666666;
	}
	.tserve1{
		display:flex;
		justify-content: space-between;
		position:absolute;
		top:10px;
		right:9px;
		width:16px;
		height:4px;
	}
	.tserve11{
		width: 4px;
		flex:0 0 4px;
		height: 4px;
		background: #0080ff;
		border-radius: 50%;
	}
    
	
    .response{
        position:absolute;
        top:35px;
        right:11px;
        width: 71px;
        height: 25px;
        border-radius: 13px;
        font-size:12px;
        text-align:center;
        line-height:25px;
        font-weight: 400;
        color:#0080FF;
		background: #dfefff;
    }
    .response1{
        position:absolute;
        top:62px;
        right:11px;
        width: 71px;
        height: 25px;
        font-size:12px;
        text-align:center;
        font-weight: 400;
        color: #0080ff;
    }
    .txt{
        width: 200px;
        height: 25px;
        margin-left:18px;
        margin-top:8px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 18px;
        font-weight: 400;
        text-align: left;
        color: #333333;
    }
	.flexRight{
		/* display:flex; */
		width:100%;
		 margin-left:18px;
		height:50px;
		padding:0 9px 5px 0px;
		box-sizing: border-box;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		text-align: left;
	}
    .subtxt{
        width: 200px;
        height: 17px;
        margin-left:18px;
        margin-top:4px;
        font-size: 10px;
        font-weight: 400;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
        text-align: left;
        color: #666666;
    }
	.subtxtn{
	    /* flex:0 0 200px; */
		width:100%;
	    /* height: 17px; */
	    /* margin-top:2px; */
	    font-size: 10px;
	    font-weight: 400;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	    text-align: left;
	    color: #666666;
	}
	.subtxtn:nth-child(1){
		margin-top:5px;
	}
    .finish{
        position:absolute;
        left:66px;
        top:4px;
        font-size:10px;
        color: #0080ff;
    }
	
</style>

 <!-- <template>
     <div :class="{cRect:true,c2Rect:!show}" @click="toDetails(item)">
         <div class="ltop" v-if="item.recordStatus=='3'" @click.stop="stopDefault">已完成</div>
         <div class="ltop" v-else-if="item.recordStatus=='1'||item.recordStatus=='2'" style="background:#ffb617" @click.stop="stopDefault">响应中</div>
 		<div class="finish" v-if="item.recordStatus=='1'">--工程师处理完成</div>
 		<div class="finish" v-if="item.recordStatus=='2'">--工程师已流转</div>
         <div class="txt">{{item.assetsId}}-{{item.assetsUserName}}-{{item.assetsName}}</div>
         <div class="subtxt">{{item.engineerName}} {{item.tel}}</div>
 		<div v-if="show">
 			<div class="evaluate" v-if="item.recordStatus=='3'&&show&&item.assessStatus==1" @click="toDetail(item.recordId)">详情</div>
 			<div class="evaluate" v-if="item.recordStatus=='3'&&show&&item.assessStatus==0" @click="estimate(item.recordId)">立即评价</div>
 			<div class="evaluate" v-else-if="(item.recordStatus=='1'||item.recordStatus=='2')&&show" @click="confirm(item)">确认完成</div>
 		</div>
         <div class="response">应急响应</div>
     </div>
 </template>
 <script>
     export default{
         props:['item'],
         data(){
             return{
                 show:true
             }
         },
         methods:{
 			toDetails(item){
 				if(item.recordStatus=='3'&&this.show&&item.assessStatus==1){
 					this.$router.push({path:'/detailInfo',query:{recordId:item.recordId}})
 				}else if(item.recordStatus=='3'&&this.show&&item.assessStatus==0){
 					this.$router.push({path:'/estimate',query:{recordId:item.recordId}})
 				}else if((item.recordStatus=='1'||item.recordStatus=='2')&&this.show){
 					this.$router.push({path:'/confirm',query:{recordId:item.recordId,engineerId:item.engineerId,finishTime:item.finishTime}})
 				}
 			},
             stopDefault(){
             	
             },
             toDetail(recordId){
 				this.$router.push({path:'/detailInfo',query:{recordId:recordId}})
             },
             estimate(recordId){
 			    this.$router.push({path:'/estimate',query:{recordId:recordId}})
             },
             confirm(item){
 				let data={
 				  "engineerId": item.engineerId,
 				  "recordId":item.recordId,
 				}
 				this.$api.post('/app/support/supportFinish',data).then(res=>{
 					if(res.data.code=="0000"&&res.data.message=="成功"){
 						this.$router.push({path:'/estimate',query:{recordId:this.$route.query.recordId}})
 					}
 				})
 			}
         }
     }
 </script>
 <style>
     .cRect{
         position:relative;
         width: 335px;
         height: 142px;
         margin:20px auto;
         background: #ffffff;
         border-radius: 8px;
         box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
     }
     .c2Rect{
         height: 100px;
     }
     .ltop{
         position:abosulte;
         top:0;
         left:0;
         width: 64px;
         height: 24px;
         background: #0080ff;
         border-radius: 8px 0px 8px 0px;
         font-size:12px;
         color:#fff;
         text-align:center;
         line-height:24px;
     }
     .evaluate{
         position:absolute;
         left:0;
         bottom:0;
         width: 100%;
         height: 37px;
         background: linear-gradient(45deg,#36b3fe 3%, #0080ff 99%);
         border-radius: 0px 0px 8px 8px;
         font-size:16px;
         text-align:center;
         line-height:37px;
         font-weight:400;
         color:#fff;
     }
     .response{
         position:absolute;
         top:28px;
         right:11px;
         width: 71px;
         height: 25px;
         background: #ffffff;
         border: 1px solid #0080ff;
         border-radius: 13px;
         font-size:12px;
         text-align:center;
         line-height:25px;
         font-weight: 400;
         color: #0080ff;
     }
     .response1{
         position:absolute;
         top:56px;
         right:11px;
         width: 71px;
         height: 25px;
         font-size:12px;
         text-align:center;
         line-height:25px;
         font-weight: 400;
         color: #0080ff;
     }
     .txt{
         width: 180px;
         height: 25px;
         margin-left:18px;
         margin-top:9px;
         text-overflow: ellipsis;
         overflow: hidden;
         white-space: nowrap;
         font-size: 18px;
         font-weight: 400;
         text-align: left;
         color: #333333;
     }
     .subtxt{
         width: 123px;
         height: 17px;
         margin-left:18px;
         margin-top:9px;
         font-size: 12px;
         font-weight: 400;
         text-align: left;
         color: #666666;
     }
 	.finish{
 	    position:absolute;
 	    left:66px;
 	    top:4px;
 	    font-size:10px;
 	    color: #0080ff;
 	}
 </style>
 -->